import { ComponentPropsWithoutRef } from 'react';
import { Collapsible, OmitStrict } from '@tanium/coreui-utils';
import styled from '@tanium/react-emotion';
import { CaretDownIcon, Icon } from '@tanium/react-graphics';
import { color, colorStylePropNames, ColorStyleProps } from '@tanium/style-system';

export interface Props
  extends OmitStrict<ComponentPropsWithoutRef<Icon>, 'color' | 'opacity'>,
    ColorStyleProps,
    Pick<Collapsible, 'isCollapsed'> {}

/**
 * Control that is typically used as part of UI that expands/collapses, often in conjunction with
 * [`useCollapsed`](https://pages.git.corp.tanium.com/eng/ufe/?path=/docs/core-ui-hooks-usecollapsed--overview).
 *
 * See [`Panel`](https://pages.git.corp.tanium.com/eng/ufe/?path=/story/core-ui-components-panel) and
 * [`PageSection`](https://pages.git.corp.tanium.com/eng/ufe/?path=/story/core-ui-components-pagesection)
 * for existing components that use `Disclosure` for showing collapsible content.
 *
 */
export const Disclosure = styled(CaretDownIcon, {
  shouldForwardProp: (prop) => ['isCollapsed', ...colorStylePropNames].indexOf(prop) === -1,
})<Props>(color, ({ isCollapsed }) => ({
  transform: isCollapsed ? 'rotate(-90deg)' : undefined,
}));

Disclosure.defaultProps = {
  height: 8,
  width: 8,
};
